export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_06.6f896ac4.jpg";